import { Button, Item, ItemActions, ItemContent, Password } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateUserPassword } from '@/entities/users';

type Props = {
  className?: string;
  id: number;
};

export const UserResetPassword: FC<Props> = (props) => {
  const { className, id } = props;

  const { t } = useTranslation(['common', 'users']);

  const [value, setValue] = useState('');

  const { isPending, mutateAsync: resetPassword } = useUpdateUserPassword();

  const handleSave = async () => {
    if (value) {
      await resetPassword({
        id,
        body: {
          password: value,
        },
      });
      setValue('');
    }
  };

  return (
    <Item variant={'outline'} className={className}>
      <ItemContent>
        <Password
          value={value}
          onChange={(e) => setValue(e.target.value)}
          label={t('users:setNewPassword')}
          autoComplete={'new-password'}
        />
      </ItemContent>
      <ItemActions className={'mt-auto'}>
        <Button variant={'secondary'} isLoading={isPending} onClick={handleSave}>
          {t('common:save')}
        </Button>
      </ItemActions>
    </Item>
  );
};
